// extracted by mini-css-extract-plugin
module.exports = {"page-background":"_2AO2a","pageBackground":"_2AO2a"};